<template>
  <div class="cover text-center border-top border-bottom pt-3 mb-3">
    <h1 v-if="base.title_note_id">
      <text-ref :id="base.title_note_id" :text="[base.title]  "/>
    </h1>
    <h1 v-else>{{base.title}}</h1>
    <h2 v-for="name in names">{{name}}</h2>
    <div class="credits text-justify">
      <p v-if="base.credits_introductory_text">{{base.credits_introductory_text}}</p>
      <p v-if="base.credits_scientific_manager"><b>Responsable científico:</b> {{base.credits_scientific_manager}}</p>
      <p v-if="base.credits_researchers"><b>Investigadores:</b> {{base.credits_researchers}}</p>
      <p v-if="base.credits_advisor"><b>Asesoría:</b> {{base.credits_advisor}}</p>
      <p v-if="base.credits_edition"><b>Edición:</b> {{base.credits_edition}}</p>
      <p v-if="base.credits_how_to_cite"><b>Cómo citar:</b> {{base.credits_how_to_cite}}</p>
      <p class="mt-3" v-if="base.funding">{{base.funding}}</p>
    </div>
    <p v-for="text in base.initial_paratext">{{text}}</p>
    <ul class="list-unstyled">
      <li v-for="character in characters">
        {{character.name}}{{character.text && ', '}}{{character.text}}.
      </li>
    </ul>
  </div>
</template>
<script>
  import zip from 'lodash/zip'
  import {mapState} from 'vuex'
  import TextRef from './TextRef'

  export default {
    components: {TextRef},
    computed: {
      ...mapState({base: s => s.document.base}),
      names() {
        return zip(this.base.author_names, this.base.author_surnames).map(a => a.join(' '))
      },
      characters() {
        return zip(this.base.character_names, this.base.character_texts).map(e => ({name: e[0], text: e[1]}))
      }
    }
  }
</script>
<style lang="scss">
  .cover .credits {
    margin: 2rem 15%;

    p {
      margin-bottom: 0;
    }
  }
</style>
